var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "boxes",
    d: "M19.5,16a1,1,0,0,1-1,1h-2a1,1,0,0,1,0-2h2A1,1,0,0,1,19.5,16ZM24,15v5a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V15a4,4,0,0,1,4-4H5V4A4,4,0,0,1,9,0h6a4,4,0,0,1,4,4v7h1A4,4,0,0,1,24,15ZM7,11H17V4a2,2,0,0,0-2-2H9A2,2,0,0,0,7,4ZM4,22h7V13H4a2,2,0,0,0-2,2v5A2,2,0,0,0,4,22Zm18-7a2,2,0,0,0-2-2H13v9h7a2,2,0,0,0,2-2ZM7.5,15h-2a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2ZM14,5a1,1,0,0,0-1-1H11a1,1,0,0,0,0,2h2A1,1,0,0,0,14,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.e7f305a6ab765d8b68df57a9142be8df.svg";
export { ForwardRef as ReactComponent };